export default __webpack_public_path__ + "static/media/photo--lg--misc-4.d57004e2.jpg";